var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnnouncementNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8.55 16.45 9 17 9H19C19.55 9 20 8.55 20 8C20 7.45 19.55 7 19 7H17C16.45 7 16 7.45 16 8Z",
    fill: "#3D5878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59 12.82C14.26 13.26 14.35 13.87 14.79 14.19C15.32 14.58 15.88 15 16.41 15.4C16.85 15.73 17.47 15.64 17.79 15.2C17.79 15.19 17.8 15.19 17.8 15.18C18.13 14.74 18.04 14.12 17.6 13.8C17.07 13.4 16.51 12.98 15.99 12.59C15.55 12.26 14.93 12.36 14.6 12.8C14.6 12.81 14.59 12.82 14.59 12.82Z",
    fill: "#3D5878"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.81 0.810045C17.81 0.800045 17.8 0.800045 17.8 0.790045C17.47 0.350045 16.85 0.260045 16.42 0.590045C15.89 0.990045 15.32 1.41004 14.8 1.81004C14.36 2.14004 14.28 2.76005 14.61 3.19005C14.61 3.20005 14.62 3.20005 14.62 3.21005C14.95 3.65005 15.56 3.74004 16 3.41004C16.53 3.02004 17.09 2.59004 17.62 2.19004C18.05 1.87004 18.13 1.25004 17.81 0.810045Z",
    fill: "#3D5878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5H2C0.9 5 0 5.9 0 7V9C0 10.1 0.9 11 2 11H3V14C3 14.55 3.45 15 4 15C4.55 15 5 14.55 5 14V11H6L11 14V2L6 5Z",
    fill: "#3D5878"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.00002C13.5 6.67002 12.92 5.47002 12 4.65002V11.34C12.92 10.53 13.5 9.33002 13.5 8.00002Z",
    fill: "#3D5878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementNotification);
export default __webpack_public_path__ + "static/media/announcement_notification.4b66dfa2e81a78e8f39db115566a9115.svg";
export { ForwardRef as ReactComponent };